/*
 * This model holds the data for curriculum api for the default locations
 *
 */
import httpClient from 'client/js/models/http-client'

class Locations {
   static async getLocations() {
      try {
         let response = await httpClient.post(BaseURL + "/api/locations/")
         return response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response)
            throw new Error(response.data.response)
         throw (err)
      };
   }
}

module.exports = Locations
